import React from 'react';
import './Linkstyles.modules.css';
import logo from './assets/logoback.jpeg'
import instagram from './assets/iinstagram.png';
import youtube from './assets/iyoutube.png';
import whatsapp from './assets/iwtsp.png';
import facebook from './assets/ifacebook.png';
import tiktok from './assets/itiktok.png';

function Links() {
    return (
        <div className='b'>
        <div className="app-container">
          <div className="app-card">
            <div className="app-icon-container">
              <img src={logo} alt="Icon" className="app-icon" />
            </div>
            <p className="app-subtitle">Suivez-nous sur les réseaux sociaux pour des mises à jour sur les voyages et inspiration</p>
            <div className="app-links">
              <a href="https://www.instagram.com/sltravelmaroc/" className="app-link app-instagram">
                <img src={instagram} alt="Instagram Icon" className="app-social-icon" />
                <span>Follow on Instagram</span>
              </a>
              <a href="https://www.facebook.com/people/SL-Travel/61551511155343/#" className="app-link app-facebook">
                <img src={facebook} alt="Facebook Icon" className="app-social-icon" />
                <span>Like us on Facebook</span>
              </a>
              <a href="https://api.whatsapp.com/send/?phone=212663290166&text&type=phone_number&app_absent=0" className="app-link app-whatsapp">
                <img src={whatsapp} alt="WhatsApp Icon" className="app-social-icon" />
                <span>Chat on WhatsApp</span>
              </a>
              <a href="https://www.youtube.com/@Sltravelmaroc" className="app-link app-youtube">
                <img src={youtube} alt="YouTube Icon" className="app-social-icon" />
                <span>Watch on YouTube</span>
              </a>
              <a href="https://www.tiktok.com/@sltravelmaroc" className="app-link app-tiktok">
                <img src={tiktok} alt="TikTok Icon" className="app-social-icon" />
                <span>Follow on TikTok</span>
              </a>
            </div>
            <footer className="app-footer">
            </footer>
          </div>
        </div>
        </div>
      );
    }
export default Links;
